import { useState } from "react";
import { useTranslation } from "react-i18next";

export function ExpandableText({
  content,
  maxLength = 200,
}: {
  content: string | null | undefined;
  maxLength?: number;
}) {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  // Normalizar o conteúdo para string
  const normalizeContent = (value: any): string => {
    if (!value || value === null || value === undefined) return "";
    if (typeof value === "string") return value;
    if (typeof value === "object") return JSON.stringify(value);
    return String(value);
  };

  const normalizedContent = normalizeContent(content);

  // Se não tem conteúdo válido, retorna mensagem padrão
  if (
    !normalizedContent ||
    normalizedContent === "Vazio" ||
    normalizedContent === `<p>${t("userGoOn:timeline.no_information")}</p>`
  ) {
    return <span className="text-gray-400 italic">{t("userGoOn:timeline.no_information")}</span>;
  }

  // Remove tags HTML para contar caracteres do texto puro
  const textContent = normalizedContent.replace(/<[^>]*>/g, "");
  const shouldTruncate = textContent.length > maxLength;

  // Função para processar links no texto
  const processLinks = (text: string) => {
    const urlRegex = /(https?:\/\/[^\s<>]+)/g;
    return text.replace(
      urlRegex,
      '<a href="$1" target="_blank" rel="noopener noreferrer" class="text-blue-500 underline">$1</a>'
    );
  };

  if (!shouldTruncate) {
    return (
      <span
        dangerouslySetInnerHTML={{ __html: processLinks(normalizedContent) }}
      />
    );
  }

  if (isExpanded) {
    return (
      <div>
        <span
          dangerouslySetInnerHTML={{ __html: processLinks(normalizedContent) }}
        />
        <button
          onClick={() => setIsExpanded(false)}
          className="ml-2 text-azul-400 underline hover:text-azul-600 text-xs"
        >
          {t("userGoOn:timeline.see_less")}
        </button>
      </div>
    );
  }

  // Truncar o HTML mantendo as tags
  const truncatedHtml =
    normalizedContent.length > maxLength
      ? normalizedContent.substring(0, maxLength) + "..."
      : normalizedContent;

  return (
    <div>
      <span dangerouslySetInnerHTML={{ __html: processLinks(truncatedHtml) }} />
      <button
        onClick={() => setIsExpanded(true)}
        className="ml-2 text-azul-400 underline hover:text-azul-600 text-xs"
      >
        {t("userGoOn:timeline.see_more")}
      </button>
    </div>
  );
}
